const stringUtils = {
  capFirstLetter: (val: string) => {
    if (val.length === 0) return "No String Provided To Capitalize";
    if (val.split(" ").length > 1) {
      const words = val.split(" ");
      return words
        .map((word) => {
          return word[0].toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
    } else {
      return val[0].toUpperCase() + (val.slice(1) || "").toLowerCase();
    }
  },
  formatDate: (val: string) => {
    const thisDate = new Date(val);
    return thisDate.toLocaleDateString("en-US", {
      timeZone: "America/Chicago",
    });
  },
};

export default stringUtils;
